import { useEffect } from "react";

import { useState } from "react";

const useReferrer = () => {
    const [referrerUrl, setReferrerUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        setReferrerUrl(document.referrer)
    }, [])

    return { referrerUrl };
};

export default useReferrer;